module.exports = __webpack_public_path__ + "gribouvideo.png?327c22a8a6671660a364076db4637fb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gribouvideo.png
// module id = 50
// module chunks = 0